const stripTrailingSlash = (value) => String(value || "").replace(/\/$/, "");

export const resolveArtistApiBaseUrl = () => {
  const envUrl = stripTrailingSlash(process.env.REACT_APP_ARTIST_BACKEND_URL);
  if (envUrl) {
    return envUrl;
  }

  if (typeof window === "undefined") {
    return "";
  }

  const { protocol, hostname } = window.location;
  const isLocalHost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "::1" ||
    hostname.endsWith(".local");
  const isPrivateIpv4 =
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname);

  if (isLocalHost || isPrivateIpv4) {
    return `${protocol}//${hostname}:4000`;
  }

  return "";
};

